const translation = {
    PageSize: 'Mida',
    PageOrientation: 'Orientació',
    Format: 'Format',
    DPI: 'DPI',
    Title: 'Exporta el mapa',
    Close: 'Tanca',
    Save: 'Desa',
    FileName: 'Nom del fitxer',
    Landscape: 'Horitzontal',
    Portrait: 'Vertical',
    PreviewHint: "Ajusta l'àrea a exportar al mapa.",
    ExportFailed: "No s'ha pogut exportar el mapa. Torna-ho a provar.",
    PreviewFailed: "No s'ha pogut generar la previsualització.",
    AdjustArea: "Ajusta l'àrea al mapa",
    AdjustAreaHint: "Mou, fes zoom, gira o inclina el mapa per enquadrar l'àrea a exportar",
    ZoomIn: 'Apropa',
    ZoomOut: 'Allunya',
    ResetZoom: 'Restableix el zoom al 100 %',
    Done: 'Fet',
    Cancel: 'Cancel·la',
    Scalebar: "Barra d'escala",
    NorthIcon: 'Icona del nord',
    ChooseNorthIcon: 'Tria la icona del nord',
    ChooseSvgFile: 'Tria un fitxer SVG',
    IconSymbol: 'Símbol de la icona',
    IconColor: 'Color de la icona',
    IconSize: 'Mida de la icona',
    InvalidSvg: 'El fitxer no és un SVG vàlid.',
    ExportAsVector: 'Exporta com a vector',
    ExportLabelsAsVector: 'Exporta les etiquetes com a vector',
    Custom: 'Personalitzat',
    Width: 'Amplada',
    Height: 'Alçada',
    LanguageName: 'Catalan',
    LanguageCode: 'ca'
};
export default translation;
